import { render } from "./ProductInfoCell.vue?vue&type=template&id=04cbd6a4&scoped=true"
import script from "./ProductInfoCell.vue?vue&type=script&lang=js"
export * from "./ProductInfoCell.vue?vue&type=script&lang=js"

import "./ProductInfoCell.vue?vue&type=style&index=0&id=04cbd6a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cbd6a4"]])

export default __exports__